import React from "react";

const PPT = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            fill="#F5B912"
            d="M29.074 10.762v21.175A2.06 2.06 0 0 1 27.02 34H8.053A2.06 2.06 0 0 1 6 31.937V4.063A2.06 2.06 0 0 1 8.053 2h12.293l8.728 8.762Z"
        />
        <path
            fill="#fff"
            d="M21.783 16.594h-8.368c-.777 0-1.405.631-1.405 1.412v8.407c0 .78.628 1.412 1.405 1.412h8.368c.777 0 1.406-.631 1.406-1.412V18c0-.775-.629-1.406-1.406-1.406Zm-.044 8.718h-8.274v-5.656h8.274v5.657Z"
        />
        <path
            fill="#000"
            d="m21.534 10.4 7.534 6.131V10.77L24.794 8.28l-3.26 2.119Z"
            opacity={0.19}
        />
        <path
            fill="#FADC87"
            d="M29.111 10.762h-6.669A2.06 2.06 0 0 1 20.39 8.7V2l8.722 8.762Z"
        />
    </svg>
);

export default PPT;
